export default "__VITE_ASSET__DGY9pZWU__"